import md5 from "md5";
import common from "../common";
import definitions from "../definitions";
import SaveDataSlot from "./SaveDataSlot";

export default class SaveData {
    constructor() {
        this._slots = {};
        this._slotsAvailable = 3;
        this._activeSlot = null;
        this._settings = {
            muted: false,
            musicMute: false,
            language: 'en',
            languageState: definitions.TRACKING.LANGUAGE_STATE.DEFAULT,
        };
        this._ratePopups = 0;

        this.init();
    }

    init() {
        this.loadGame();
    }

    /**
     * @param {number} id
     * @param {boolean} [overwrite=false]
     */
    createEmptySlot(id, overwrite= false) {
        if (!this._slots[id] || overwrite) {
            this._slots[id] = new SaveDataSlot(id);

            this.saveGame();

            //console.log("[" + this.constructor.name + "]", "Empty slot(" + id + ") created")
        }
    }

    loadGame() {
        try {
            if(localStorage){}
        } catch (error) {
            return;
        }
        let data = localStorage.getItem(common.config.storage.id);
        if (data) {
            data = JSON.parse(data);

            if (this.checkSaveVersion(data)) {
                for (let i in data.slots) {
                    if (data.slots.hasOwnProperty(i)) {
                        const id = parseInt(i);
                        const slot = data.slots[id];
                        this._slots[id] = new SaveDataSlot(id);
                        this._slots[id].player = slot.player;
                        this._slots[id].quests = slot.quests;
                        this._slots[id].inventory = slot.inventory;
                        this._slots[id].coins = slot.coins == undefined ? 10 : slot.coins;
                        this._slots[id].acorns = slot.acorns || [];
                        this._slots[id].treasures = slot.treasures || [];
                        this._slots[id].goldenTurnips = slot.goldenTurnips || [];
                        this._slots[id].purchases = slot.purchases || {};
                        this._slots[id].unlocks = slot.unlocks || [];
                    }
                }
                this._settings = data.settings || this._settings;
                if(data.ratePopups != undefined) {
                    this._ratePopups = data.ratePopups;
                }
                //console.log('SAVE DATA: ', JSON.stringify(data));
            }
        }
        //console.log("[" + this.constructor.name + "]", "Game loaded")
    }

    saveGame() {
        try {
            if(localStorage){}
        } catch (error) {
            return;
        }

        const data = {
            version: common.config.storage.version,
            slots: {},
            settings: this._settings,
            ratePopups: this._ratePopups
        };

        for (const id in this._slots) {
            if (this._slots.hasOwnProperty(id)) {
                const slot = this._slots[id];
                data.slots[slot.id] = slot.toObject();
            }
        }

        data.hash = md5(data + "dd8036ae6012266cf575c5aacb8443ad");
        localStorage.setItem(common.config.storage.id, JSON.stringify(data));
    }

    /**
     * @param {object} data
     * @return {boolean}
     */
    checkSaveVersion(data) {
        return data.version === common.config.storage.version;
    }

    /**
     * @param {number} slot
     * @return {SaveDataSlot}
     */
    getSlot(slot) {
        return this._slots[slot];
    }

    /**
     * @return {SaveDataSlot}
     */
    get activeSlot() {
        return this._activeSlot;
    }

    /**
     * @return {Object}
     */
    get settings() {
        return this._settings;
    }

    /**
     * @return {number}
     */
    get slotsAvailable() {
        return this._slotsAvailable;
    }

    /**
     * @param {number} id
     */
    setActiveSlot(id) {
        this._activeSlot = this._slots[id];
        if (!this._activeSlot) {
            throw new Error("[SaveData] Trying to set an active slot(" + id + ") that does not exist");
        }
    }

    areAllSlotsEmpty() {
        for (let i = 0; i < this._slotsAvailable; i++) {
            if (!this.isSlotEmpty(i)) {
                return false;
            }
        }
        return true;
    }

    isActiveSlotEmpty() {
        return this.isSlotEmpty(0);
    }

    /**
     * @param {number} slot
     */
    isSlotEmpty(slot) {
        return this._slots[slot] == null || JSON.stringify(new SaveDataSlot(slot).toObject()) == JSON.stringify(this._slots[slot].toObject());
    }

    incrementRatePopUps() {
        if(this._ratePopups + 1 > 3) {
            return;
        }
        this._ratePopups++;
        this.saveGame();
    }

    clearRatePopUps() {
        this._ratePopups = 3;
        this.saveGame();
    }

    get haveReachedRatePopUpLimit() {
        return this._ratePopups >= 3;
    }
}